import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';

import { NgbActiveModal, NgbModalRef, NgbDateStruct, NgbTimeStruct, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, DateUtils } from 'ng-jhipster';

import { School, SchoolService } from '../school';
import { Student, StudentService, StudentTypeaheadService } from '../student';
import { Location, LocationService } from '../location';
import { Principal, CRUD_ACTIONS, DateUtilities } from '../../shared';
import { EventReservationPopupService } from './event-reservation-popup.service';
import { Event } from '../event/event.model';
import { EventReservation } from './event-reservation.model';
import { EventReservationService } from './event-reservation.service';
import { AbstractDialogComponent } from '../abstract-dialog-component/abstract-dialog.component';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { JhiLanguageService } from 'ng-jhipster';

import { SERVER_DATE_TIME_FORMAT } from '../../shared/constants/date-time.constants';



@Component({
    selector: 'jhi-event-reservation-dialog',
    templateUrl: './event-reservation-dialog.component.html'
})
export class EventReservationDialogComponent extends AbstractDialogComponent implements OnInit {

    eventReservation: EventReservation;

    isSaving: boolean;

    search = this.studentTypeaheadService.search;
    resultFormatter = this.studentTypeaheadService.resultFormatter;
    inputFormatter = (student: any) => this.studentTypeaheadService
                                            .inputFormatter(student, () => this.eventReservation.student['user']);


    constructor(
            public activeModal: NgbActiveModal,
            alertService: AlertService,
            schoolService: SchoolService,
            private studentTypeaheadService: StudentTypeaheadService,
            private locationService: LocationService,
            private eventReservationService: EventReservationService,
            private eventManager: EventManager,
            private dateUtils: DateUtils,
            private datePipe: DatePipe,
            principal: Principal,
            private router: Router,
            private languageService: JhiLanguageService,
    ) {
        super(schoolService, alertService, principal);
        this.languageService.setLocations(['event', 'eventStatus',
            'eventCategory', 'eventReservationStatus',
            'eventReservation', 'student', 'user-management']);
    }

    ngOnInit(): void {
        this.isSaving = false;
    }

    save(form: NgForm) {
        if (this.eventReservation.student instanceof Object) {
            this.isSaving = true;
            if (this.eventReservation.id !== undefined) {
                this.eventReservationService.update(this.eventReservation)
                    .subscribe((res: EventReservation) =>
                        this.onSaveSuccess(res, CRUD_ACTIONS.UPDATE), (res: HttpErrorResponse) => this.onSaveError(res));
            } else {
                this.eventReservationService.create(this.eventReservation)
                    .subscribe((res: EventReservation) =>
                        this.onSaveSuccess(res, CRUD_ACTIONS.CREATE), (res: HttpErrorResponse) => this.onSaveError(res));
            }
        } else {
            let studentInput = form !== undefined ? form.controls['student'] : null;
            if (studentInput !== null) {
                studentInput.reset();
            }
        }

    }

    private onSaveSuccess(result: Event, action: String) {
        this.eventManager.broadcast({ name: 'eventParticipantsListModification',
            content: {
                action: action,
                content: result
            }
        });

        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        this.isSaving = false;
        this.onError(error);
    }


    clear() {
        this.activeModal.dismiss('cancel');
    }
}

@Component({
    selector: 'jhi-event-reservation-popup',
    template: ''
})
export class EventReservationPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private eventReservationPopupService: EventReservationPopupService
    ) {

    }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if (params['id']) {
                this.modalRef = this.eventReservationPopupService
                    .open(EventReservationDialogComponent as Component, params['id']);
            } else if (params['studentId']) {
                this.modalRef = this.eventReservationPopupService
                    .open(EventReservationDialogComponent as Component, undefined, params['studentId']);
            } else if (params['eventId']) {
                this.modalRef = this.eventReservationPopupService
                    .open(EventReservationDialogComponent as Component, undefined, undefined, params['eventId']);
            }
        });

    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/event-reservation/event-reservation-dialog.component.ts